import { useHeaderState } from "@faire/deprecated-retailer-visitor-shared/components/Header/useHeaderState";
import { SDUIOnClickHandler } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { SDUIComponentInstanceRendererProps } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { SDUITextRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Typography/SDUITextRenderer";
import { optimizeImageUrl } from "@faire/web/common/images/optimizeImages";
import { useCallback } from "react";

export const SDUISimpleActionBannerRenderer: React.FC<
  SDUIComponentInstanceRendererProps
> = ({ component, loggingData }) => {
  const { simple_action_banner_component } = component;
  const { hideSearchQuery } = useHeaderState();

  const onBannerClick = useCallback(() => {
    hideSearchQuery();
  }, [hideSearchQuery]);

  if (!simple_action_banner_component) {
    return null;
  }

  const { main_image, main_text, on_click } = simple_action_banner_component;

  return (
    <SDUIOnClickHandler onClickActions={on_click} loggingData={loggingData}>
      <div
        className="border-core-border-muted flex h-14 w-full items-center rounded-sm border px-2 pt-2 pb-2"
        onClick={onBannerClick}
        data-test-id="SDUI-simple-action-banner"
      >
        {main_image?.image?.url ? (
          <div
            className="m-1 mr-2 ml-1 h-8 w-8 rounded-sm bg-cover bg-center"
            style={{
              backgroundImage: `url(${
                optimizeImageUrl({ url: main_image.image.url }, false, {
                  height: 40,
                  width: 40,
                  resizeMethod: "fill",
                }) ?? ""
              })`,
            }}
          />
        ) : null}
        <SDUITextRenderer text={main_text} />
      </div>
    </SDUIOnClickHandler>
  );
};
